const pixelIds = {
  "-MW2M4tJakuYczP6HfZr": "1464344030353690",
  "-MW2M4tJakuYczP6HfZa": "1185006008641458",
  "-LmVplLkkVMZbzJStwE7": "1185006008641458",
  "-MW2M4tJakuYczP6HfZn": "1185006008641458",
  "-MW2M4tJakuYczP6HfZd": "1670016773351174",
  "-NW2M4tJakuYczP6HfZi": "395187705899612",
  "-NU9ZgQVDtia7Oe2wOzy": "436457029418494",
  "-MW2M4tJakuYczP6HfZx": "2049377965224494",
  "-NNJaFoGcfkDOcu9aMkk": "627312672950476",
  "-NsDkDRUpnrMQAudNHb2": "608102828933392"
};

export default pixelIds;


// WEBPACK FOOTER //
// ./src/api/fbPixelConfig.js